import {vSubscriptionPlanBase} from '../database-models/v-subscription-plan-base';
//Generated Imports
import { actionColumn } from '@rxweb/grid';
@actionColumn({
    name: 'action',
    allowSorting: false,
    configuredTemplate: { templateName: 'action' }, columnIndex: 0, headerTitle: "Action", class: ["actionFild"],headerCellClass:["pl-4"]
})
export class vSubscriptionPlan extends vSubscriptionPlanBase 
{




//#region Generated Reference Properties

//#endregion Generated Reference Properties













}